import css from "./ModalForm.module.css";

function ModalForm({ showModal, toggleModal, children }) {
    // const handleBackdropClick = (e) => {
    //     e.stopPropagation();
    //     toggleModal();
    // };

    return (
        <>
            {showModal && (
                <div className={css.backdrop} >
                {/* <div className={css.backdrop} onClick={handleBackdropClick}> */}
                    <div className={css.modal}>{children}</div>
                </div>
            )}
        </>
    );
}

export default ModalForm;
